import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

/** The member's own season numbers, three big figures. */
@observer
class AdventStatsDoor extends Component {
    render() {
        const { door = {} } = this.props;
        const content = door.content || {};
        return (
            <div>
                <div class='fs-5 fw-bold mb-3'>{content.title}</div>
                {content.empty || !(content.items || []).length ? (
                    <div class='alert alert-info'>
                        <Text id='adventCalendar.statsEmpty'>No starts registered this year yet. We look forward to next season!</Text>
                    </div>
                ) : (
                    <div class='row g-3'>
                        {content.items.map(item => (
                            <div key={`advent-stat-${item.label}`} class='col-4'>
                                <div class='card text-center h-100'>
                                    <div class='card-body py-3'>
                                        <div class='fs-2 fw-bold'>{item.value}</div>
                                        <div class='small text-body-secondary'>{item.label}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default AdventStatsDoor;
